import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPCylindo3dViewer from 'components/consumer/PDP/PDPCylindo3dViewer';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import PDPDecideLaterOverlay from 'components/consumer/PDP/PDPDecideLaterOverlay';
import usePDPGalleryInteractedEvent from 'data-hooks/useEvents/usePDPGalleryInteractedEvent';
import { GALLERY_IMAGE_LOCATION, GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPMobileConfigurationPhotoGallery3dViewer from './PDPMobileConfigurationPhotoGallery3dViewer';
import PDPMobileDimensionsIcon from '../PDPMobileDimensionsIcon';
const PDPMobileConfigurationPhotoGalleryUI = t0 => {
  const $ = _c(33);
  const {
    isEditOrder: t1,
    enableCrops: t2,
    photos: t3,
    productName,
    cylindoFeatures,
    isCylindoAvailable,
    showDecideLaterOverlay: t4,
    isConfigFlipped: t5,
    viewGalleryImageEvent,
    shouldShowDimensionThumbnail: t6,
    upholsteryKey
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const enableCrops = t2 === undefined ? true : t2;
  let t7;
  if ($[0] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const photos = t7;
  const showDecideLaterOverlay = t4 === undefined ? false : t4;
  const isConfigFlipped = t5 === undefined ? false : t5;
  const shouldShowDimensionThumbnail = t6 === undefined ? false : t6;
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  const {
    trackGalleryInteracted
  } = usePDPGalleryInteractedEvent();
  let t8;
  if ($[2] !== isDimensionsModalOpen || $[3] !== trackGalleryInteracted) {
    t8 = () => {
      if (!isDimensionsModalOpen) {
        trackGalleryInteracted(GALLERY_INTERACTION.MEASURE_ACTIVATED);
      }
      setIsDimensionsModalOpen(true);
    };
    $[2] = isDimensionsModalOpen;
    $[3] = trackGalleryInteracted;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const openDimensionsModal = t8;
  let t9;
  if ($[5] !== cylindoFeatures || $[6] !== enableCrops || $[7] !== isConfigFlipped || $[8] !== isCylindoAvailable || $[9] !== isEditOrder || $[10] !== openDimensionsModal || $[11] !== photos || $[12] !== productName || $[13] !== selectedCarouselIndex || $[14] !== showDecideLaterOverlay || $[15] !== viewGalleryImageEvent) {
    t9 = isCylindoAvailable ? <BrowserOnly><PDPMobileConfigurationPhotoGallery3dViewer hidden={!isCylindoAvailable}><PDPCylindo3dViewer cylindoFeatures={cylindoFeatures} isMobile={true} /></PDPMobileConfigurationPhotoGallery3dViewer></BrowserOnly> : <PDPMobileCarousel isEditOrder={isEditOrder} enableCrops={enableCrops} photos={photos} productName={productName} showDecideLaterOverlay={showDecideLaterOverlay} setSelectedCarouselIndex={setSelectedCarouselIndex} selectedCarouselIndex={selectedCarouselIndex} onDimensionsIconClick={showDecideLaterOverlay ? _temp : openDimensionsModal} isConfigFlipped={isConfigFlipped} onAfterSlide={photo => {
      const position = photos.findIndex(t10 => {
        const {
          src
        } = t10;
        return src === photo?.src;
      });
      if (position !== -1) {
        viewGalleryImageEvent({
          imageLocation: GALLERY_IMAGE_LOCATION.CONFIGURATION,
          imageFilename: photo.src?.split("/").pop() || "",
          totalImages: photos.length,
          position
        });
      }
    }} />;
    $[5] = cylindoFeatures;
    $[6] = enableCrops;
    $[7] = isConfigFlipped;
    $[8] = isCylindoAvailable;
    $[9] = isEditOrder;
    $[10] = openDimensionsModal;
    $[11] = photos;
    $[12] = productName;
    $[13] = selectedCarouselIndex;
    $[14] = showDecideLaterOverlay;
    $[15] = viewGalleryImageEvent;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== showDecideLaterOverlay) {
    t10 = showDecideLaterOverlay && <PDPDecideLaterOverlay />;
    $[17] = showDecideLaterOverlay;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setIsDimensionsModalOpen(false);
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== upholsteryKey) {
    t12 = <PDPDimensionsContent upholsteryKey={upholsteryKey} />;
    $[20] = upholsteryKey;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isDimensionsModalOpen || $[23] !== t12) {
    t13 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t11}>{t12}</MobileModal>;
    $[22] = isDimensionsModalOpen;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== openDimensionsModal || $[26] !== shouldShowDimensionThumbnail) {
    t14 = shouldShowDimensionThumbnail && <div className="absolute right-4 top-4 z-[5] flex flex-col gap-2"><PDPMobileDimensionsIcon onClick={openDimensionsModal} /></div>;
    $[25] = openDimensionsModal;
    $[26] = shouldShowDimensionThumbnail;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t14 || $[31] !== t9) {
    t15 = <div className="relative min-h-[100vw]" data-xc="PDPMobileConfigurationPhotoGalleryUI">{t9}{t10}{t13}{t14}</div>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
    $[31] = t9;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
PDPMobileConfigurationPhotoGalleryUI.propTypes = {
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  isCylindoAvailable: PropTypes.bool,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  showDecideLaterOverlay: PropTypes.bool,
  viewGalleryImageEvent: PropTypes.func,
  isConfigFlipped: PropTypes.bool,
  shouldShowDimensionThumbnail: PropTypes.bool,
  upholsteryKey: PropTypes.string
};
export default PDPMobileConfigurationPhotoGalleryUI;
function _temp() {}